import React from 'react';
import PropTypes from 'prop-types';
import { CircleChart } from '../../../../../CircleChart';
import { SavingsBarChart } from './components/SavingsBarChart';

import './SavingsBreakdownCard.less';

export const SavingsBreakdownCard = (props) => {
  const { title, color, hasBreakdown = false, theme } = props;

  return (
    <div className="savings-breakdown-card">
      <div className="savings-breakdown-card--header">
        <div className="savings-breakdown-card--title">
          <div className="savings-breakdown-card--main">{title}</div>
          <div className="savings-breakdown-card--secondary">Last updated: 2021-03-01 00:12</div>
        </div>
        <div className="savings-breakdown-card--equipment">{`${title} by Equipment`}</div>
        <div className="savings-breakdown-card--download">Download Report</div>
      </div>
      <div className="savings-breakdown-card--body">
        <div className="savings-breakdown-card--circle-graph">
          <CircleChart color={color} theme={theme} />
        </div>
        <div className="savings-breakdown-card--bar-graph">{hasBreakdown && <SavingsBarChart />}</div>
      </div>
      <div className="savings-breakdown-card--legend">
        <div className="savings-breakdown-card--legend-item">
          <div className="savings-breakdown-card--legend-circle" style={{ 'background-color': color }} />
          Actual Savings
        </div>
        <div className="savings-breakdown-card--legend-item">
          <div className="savings-breakdown-card--legend-circle goal" />
          Savings Goal
        </div>
        <div className="savings-breakdown-card--legend-item">
          <div className="savings-breakdown-card--legend-circle exceeded" />
          Savings Exceeded
        </div>
        <div className="savings-breakdown-card--legend-item">
          <div className="savings-breakdown-card--legend-circle negative" />
          Negative Savings
        </div>
      </div>
    </div>
  );
};

SavingsBreakdownCard.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  hasBreakdown: PropTypes.bool,
};

SavingsBreakdownCard.defaultProps = {
  hasBreakdown: false,
};
